import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Popconfirm } from 'antd';
import { DollarCircleOutlined, LogoutOutlined, UserOutlined, BankOutlined, FileAddOutlined, 
  FileSearchOutlined, DashboardOutlined, DatabaseOutlined, SolutionOutlined, CheckCircleOutlined,
  FileTextOutlined, RightOutlined,AuditOutlined } from '@ant-design/icons';
import * as Styled from './style.js';
import logo from '../../assets/images/sp-finance-logo-2.png';

function SideBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [openGroups, setOpenGroups] = useState({});

  const logout = () => {
    localStorage.setItem('access_id', '');
    localStorage.setItem('user_role', '');
    localStorage.setItem('user_name', '');
    localStorage.setItem('selectedMonth', '');
    navigate('/');
    window.location.reload();
  };

  const menuItems = [
    {
      path: '/',
      label: 'Dashboard',
      icon: DashboardOutlined
    },
    {
      label: 'Collection',
      icon: BankOutlined,
      children: [
        {
          path: '/collection-summary',
          label: 'Verification',
          extraPaths: ['/collection-verification'],
          icon: CheckCircleOutlined
        },
        {
          path: '/subscriptionLogs',
          label: 'Edit Logs',
          icon: FileTextOutlined
        }
      ]
    },
    {
      path: '/phonepe',
      label: 'Phone Pe Entries',
      icon: DollarCircleOutlined,
      extraPaths: ['/phonepe-list'] 
    },
    {
      path: '/razorpay',
      label: 'Razorpay Entries',
      icon: DollarCircleOutlined,
      extraPaths: ['/razorpay-collection'] 
    },
    // {
    //   path: '/bank',
    //   label: 'Bank Entries',
    //   icon: DollarCircleOutlined,
    //   extraPaths: ['/bank-collection'] 
    // },
    {
      path: '/revenue',
      label: 'Revenue',
      icon: DollarCircleOutlined
    // },
    // {
    //   path: '/buddyinfo',
    //   label: 'Buddy Details',
    //   icon: SolutionOutlined,
    //   extraPaths: ['/buddyData'] 
    },
    {
      path: '/gst/summary',
      label: 'Tax',
      icon: AuditOutlined
    }
  ];

  return (
    <Styled.Sidebar>
      <Styled.SidebarContainer>
        <Styled.SidebarLogoContainer>
          <Styled.Logo src={logo} alt="logo" />
        </Styled.SidebarLogoContainer>

        <Styled.SidebarContainer>
          <Styled.SidebarMenuContainer>
            {/* <Styled.SidebarSubMenu>Overview</Styled.SidebarSubMenu> */}
            <Styled.SidebarItems>
              
              {menuItems.map(item => {
                const Icon = item.icon;
                const hasChildren = item.children && item.children.length;

                const isParentActive = hasChildren
                  ? item.children.some(child =>
                      location.pathname === child.path || (child.extraPaths && child.extraPaths.some(p => location.pathname.includes(p)))
                    )
                  : false;

                const isActive =
                  location.pathname === item.path || (item.extraPaths && item.extraPaths.some(p => location.pathname.includes(p))) || isParentActive;

                const open = openGroups[item.label] ?? isParentActive;

                return (
                  <div key={item.label}>
                    {hasChildren ? (
                      <Styled.MenuOption
                        active={isActive}
                        onClick={() => {
                          // open the submenu and navigate to first child
                          setOpenGroups(prev => ({ [item.label]: true }));
                          if (item.children && item.children[0] && item.children[0].path) {
                            navigate(item.children[0].path);
                          }
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {Icon && (
                          <Icon style={{ color: isActive ? '#fcd533' : '#cbd5e1' }} />
                        )}
                        <Styled.MenuLabel active={isActive}>
                          {item.label}
                        </Styled.MenuLabel>
                        <RightOutlined style={{ marginLeft: 'auto', transform: open ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.18s ease', color: isActive ? '#fcd533' : '#cbd5e1' }} />
                      </Styled.MenuOption>
                    ) : (
                      <Link to={item.path} key={item.path} onClick={() => setOpenGroups({})}>
                        <Styled.MenuOption active={isActive}>
                          {Icon && (
                            <Icon style={{ color: isActive ? '#fcd533' : '#cbd5e1', transition: '0.2s' }} />
                          )}
                          <Styled.MenuLabel active={isActive}>{item.label}</Styled.MenuLabel>
                        </Styled.MenuOption>
                      </Link>
                    )}

                    {hasChildren && open && item.children.map(child => {
                      const ChildIcon = child.icon;
                      const isActiveChild =
                        location.pathname === child.path || (child.extraPaths && child.extraPaths.some(p => location.pathname.includes(p)));

                      return (
                        <Link to={child.path} key={child.path}>
                          <Styled.MenuOption active={isActiveChild} isSubMenu={true}>
                            {ChildIcon && (
                              <ChildIcon style={{ color: isActiveChild ? '#fcd533' : '#cbd5e1' }} />
                            )}
                            <Styled.MenuLabel active={isActiveChild}>{child.label}</Styled.MenuLabel>
                          </Styled.MenuOption>
                        </Link>
                      );
                    })}
                  </div>
                );
              })}

              {/* <Link to="/salaryDetails">
                <Styled.MenuOption active={location.pathname === '/salaryDetails'}>
                  <DatabaseOutlined />
                  <Styled.MenuLabel>Salary Details</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>
              <Link to="/addBuddyData">
                <Styled.MenuOption active={location.pathname === '/addBuddyData'}>
                  <SolutionOutlined />
                  <Styled.MenuLabel>Add Buddy Data</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link> */}

              {/* <Link to="/expenseDetails">
                <Styled.MenuOption active={location.pathname === '/expenseDetails'}>
                  <SolutionOutlined />
                  <Styled.MenuLabel>Expense Details</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link> */}

              {/* Uncomment the below code if required */}
              {/* <Link to="/addContract">
                <Styled.MenuOption active={location.pathname === '/addContract'}>
                  <FileAddOutlined />
                  <Styled.MenuLabel>Add Contract</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link> */}

              {/*<Styled.SidebarSubMenu>Venue Management</Styled.SidebarSubMenu>*/}

              {/*<Link to="/contractInfo">
                <Styled.MenuOption active={location.pathname === '/contractInfo'}>
                  <FileAddOutlined style={{ color: '#fcd533' }} />
                  <Styled.MenuLabel>Contracts</Styled.MenuLabel>
                </Styled.MenuOption>
              </Link>*/}

              
            </Styled.SidebarItems>
          </Styled.SidebarMenuContainer>

          <Popconfirm
            title="Are you sure to logout?"
            onConfirm={logout}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Styled.SidebarFooter>
              <Styled.SidebarFooterLabel>
                <UserOutlined />
                <Styled.Username> {localStorage.getItem('user_name')} </Styled.Username>
              </Styled.SidebarFooterLabel>
              <LogoutOutlined className="sidebar-item-icon" />
            </Styled.SidebarFooter>
          </Popconfirm>

        </Styled.SidebarContainer>
      </Styled.SidebarContainer>
    </Styled.Sidebar>
  );
}

export default SideBar;
